import {
  isDateRangeFilter,
  setDateValidationErrors,
} from '@user/components/Filters'
import { IOpportunity, OpportunityFilterSet } from '@user/store/opportunity'
import { FormikErrors } from 'formik'

export function validateOppFilters(values: OpportunityFilterSet) {
  const { filters } = values

  const errors: FormikErrors<OpportunityFilterSet> = {}
  for (const filter in filters) {
    if (isDateRangeFilter<IOpportunity>(filters[filter])) {
      setDateValidationErrors(filters[filter], errors)
    }
  }

  return errors
}
